module.exports = __webpack_public_path__ + "img/NF.8ec36b5e.png";